// Définition des constantes de temps avec précision
export const WORKING_DAY = {
  hours: 7,
  minutes: 34
};

// Calculer avec précision en utilisant une division décimale
export const WORKING_DAY_IN_HOURS = Number((WORKING_DAY.hours + (WORKING_DAY.minutes / 60)).toFixed(2));
export const FULL_DAY_HOURS = WORKING_DAY_IN_HOURS;
export const HALF_DAY_HOURS = Number((WORKING_DAY_IN_HOURS / 2).toFixed(2));

// Conversion en minutes totales pour les calculs
export const MINUTES_IN_DAY = (WORKING_DAY.hours * 60) + WORKING_DAY.minutes;
